__turbopack_context__.v({
  "bottom": "Footer-module__3hUVsW__bottom",
  "brandCol": "Footer-module__3hUVsW__brandCol",
  "column": "Footer-module__3hUVsW__column",
  "columns": "Footer-module__3hUVsW__columns",
  "footer": "Footer-module__3hUVsW__footer",
  "inner": "Footer-module__3hUVsW__inner",
  "link": "Footer-module__3hUVsW__link",
  "list": "Footer-module__3hUVsW__list",
  "newsletter": "Footer-module__3hUVsW__newsletter",
  "newsletterDone": "Footer-module__3hUVsW__newsletterDone",
  "tagline": "Footer-module__3hUVsW__tagline",
  "top": "Footer-module__3hUVsW__top",
  "wordmark": "Footer-module__3hUVsW__wordmark",
});
